export const routes = [
    {
        name: 'home',
        path: ['/home','/'],
        page: 'front'
    },
    {
        name: 'detalle-receta',
        path: '/preparacion-de-las-mezclas/:path',
        component: 'slider'
    },
    {
        name: 'ranking',
        path: ['/game-ranking'],
        page: 'ranking'
    },
    {
        name: 'game',
        path: ['/juega-y-gana'],
        page: 'game'
    },
    {
        name: 'questions',
        path: ['/preguntas'],
        page: 'questions'
    },
    {
        name: 'login',
        path: ['/iniciar-sesion'],
        page: 'login'
    },
    {
        name: 'formTrivia',
        path: ['/trivia', '/juego'],
        page: 'validateForm'
    },
]